export const ATTRIBUTE_AND_RULE_ERR = {
    duplicateInformation: 'Duplicate information.',
    invalidInformation: 'Invalid information.'
}